// src/components/Config/ConfigSection.jsx
import React from "react";
import ConfigField from "./ConfigField";

export default function ConfigSection({ category, schema, data, metaData, onChange, onMetaChange, sideActions = {} }) {
  return (
    <div 
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
        background: "#fafafa",
      }}
    >
      {schema.map((field) => (
        <ConfigField
          key={field.key}
          category={category}
          fieldKey={field.key}
          label={field.label}
          value={data?.[field.key] ?? ""}
          type={field.type}
          options={field.options || []}
          meta={metaData?.[field.key] || { public: false, system: false, secure: false }}
          onMetaChange={onMetaChange} // ⚡ أضف هذا
          isAdmin={true} // 👈 لاحقًا بنبدلها بدور المستخدم
          onChange={onChange}
          sideAction={sideActions[field.key]}
        />
      ))}
    </div>
  );
}
